AgrimarketControllers.controller('userContractsBaseMonitoringController', ['$scope', '$routeParams',
    function ($scope, $routeParams) {
        $scope.subTabIndex = $routeParams.subTabIndex;
        $scope.idProduct = $routeParams.idProduct;
        $scope.idCrop = $routeParams.idCrop;
    }]);
 